import styled from "styled-components";

export const CloseTopDrawer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        justify-content: flex-end;
    }
`;


export const HeaderDrawer = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 15px;
    border-top: 2px solid var(--border-color);
    border-bottom: 2px solid var(--border-color);

    .HeaderDrawer__info {
        display: flex;
        flex-direction: column;
        gap: 3px;

        span {
            font-size: 11px;
            color: var(--text-color-light);
            font-weight: 600;
        }
    }
`;

export const BodyDrawer = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 15px;
`;

export const FooterDrawer = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    gap: 10px;
    border-top: 2px solid var(--border-color);
    box-sizing: border-box;
    padding: 15px;
    box-shadow: 0px -5px 20px -19px rgb(0,0,0,0.5);
`;